import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '@/stores/authStore';
import { User } from '@/types';

export const useAuth = () => {
  const {
    user,
    isAuthenticated,
    isLoading,
    login,
    register,
    logout,
    refreshUser,
  } = useAuthStore();

  // Initialization is now handled by AuthProvider

  // Auto-refresh user data periodically if authenticated
  useEffect(() => {
    if (isAuthenticated && user) {
      const interval = setInterval(() => {
        refreshUser();
      }, 15 * 60 * 1000); // 15 minutes

      return () => clearInterval(interval);
    }
  }, [isAuthenticated, user, refreshUser]);

  return {
    user,
    isAuthenticated,
    isLoading,
    login,
    register,
    logout,
    refreshUser,
  };
};

/**
 * Retired. `GET /api/auth/users` is gone (410). Use `useAssignableUsers(clientId)`.
 */
export const useUsers = () => {
  return useQuery<User[]>({
    queryKey: ['users'],
    queryFn: async () => [],
    enabled: false,
    staleTime: Infinity,
  });
};

export default useAuth;